import { Component , HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from "./shared/navbar/navbar.component";
import { FooterComponent } from './shared/footer/footer.component';
import { DataService } from './core/services/data/data.service';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './features/dashboard/login/login.component';
declare let AOS : any;  
import Swal from 'sweetalert2';
import { AudioService } from './core/services/audio/audio.service';
import { NotificationService } from './core/services/notification/notification.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavbarComponent , FooterComponent , CommonModule, LoginComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent { 
  title = 'hurghadaradio';

  constructor( 
    private DataService : DataService ,
    public audioService: AudioService ,
    private notificationService: NotificationService
  ) {}

  isNavbarHidden = false; // To toggle the navbar visibility
  lastScrollPosition = 0; // To store the last scroll position 

  // @HostListener('contextmenu', ['$event'])
  // onRightClick(event: Event): void {
  //   event.preventDefault();
  // }

  // @HostListener('document:keydown', ['$event'])
  // handleKeyboardEvent(event: KeyboardEvent): void {
  //   if ((event.ctrlKey && event.shiftKey && event.code === 'KeyI') ||  // Ctrl+Shift+I
  //       (event.ctrlKey && event.shiftKey && event.code === 'KeyC')) { // Ctrl+Shift+C
  //     event.preventDefault();
  //   }
  // }

  ngOnInit(): void { 
    AOS.init() ;

     // Ask for notifications after a delay / user interaction:
     setTimeout(() => {
      this.notificationService.requestPermissionAndSaveToken();
      this.notificationService.listenForegroundMessages();
    }, 5000);

    if (localStorage.getItem('hurghadaradioLang') == 'en') {
      this.DataService.isArabic = false;
    } else {
      this.DataService.isArabic = true;
    }
  
    this.direction () ;

    setTimeout(() => {
      this.showAdsPopup();
    }, 3000);
  
  }

  onActivate() {
    window.scroll(0,0) ;
  }

  toTop () {
    window.scrollTo({
      top : 0 ,
      behavior:'smooth'      
    })
  }
  
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.scr();
    this.scrNavbar();
  }

  scr() {
    if (window.scrollY >= 200) {
      document.querySelector('.toTop')?.classList.add('top-show');
    } else {
      document.querySelector('.toTop')?.classList.remove('top-show');
    }
  } 

  scrNavbar () {
    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

  // If scrolling down, hide the navbar
  if (currentScrollPosition > this.lastScrollPosition) {
    this.isNavbarHidden = true;
  } 
  // If scrolling up, show the navbar
  else if (currentScrollPosition < this.lastScrollPosition) {
    this.isNavbarHidden = false;
  }
  // Update the last scroll position
  this.lastScrollPosition = currentScrollPosition;
  } 

  direction() {
    if (this.DataService.isArabic) {
        document.querySelector('.direction')?.classList.add('rtl');
      } else {
        document.querySelector('.direction')?.classList.remove('rtl');
      }
      setTimeout(() => { this.direction() }, 100);
  }  

  showAdsPopup() {
    Swal.fire({
      title: '😍 للإعلان على راديو الغردقة 📢',
      // html: `
      //   <p class="mb-3">اضغط على الزر المناسب:</p>
      // `,
      icon: 'info',
      showCancelButton: true,
      cancelButtonText: `
         <i class="fa-solid fa-xmark mx-2"></i>
         <span>إغلاق</span>
      `,
      confirmButtonText: `
         <i class="fa-brands fa-whatsapp mx-2"></i>
         <span>تواصل عبر واتساب</span>
      `,
      confirmButtonColor: '#25D366',
      cancelButtonColor: '#d33',
      showDenyButton: !this.audioService.isPlaying,   // زر الراديو يظهر فقط لو مش شغال
      denyButtonText: `
         <i class="fa-solid fa-play mx-2"></i>
         <span>اضغط هنا لتشغيل الراديو</span>
      `,
      denyButtonColor: '#0d6efd'
    }).then((result) => {
  
      // زر واتساب
      if (result.isConfirmed) {
        window.open(
          'https://wa.me/201004640868?text=مرحبًا، أريد الإعلان على راديو الغردقة ❤️',
          '_blank'
        );
      }
  
      // زر تشغيل الراديو
      if (result.isDenied) {
        this.audioService.playAudio();
      }
  
    });
  }
  
  

}
